<template>
  <div class="dashboard-container">
    <el-card shadow="hover">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="资金流水" name="first">
          <div style="margin-bottom: 20px;">
            <el-button size="small" @click="queryData(1)">今日</el-button>
            <el-button size="small" @click="queryData(2)">本周</el-button>
            <el-button size="small" @click="queryData(3)">本月</el-button>
            <el-button size="small" @click="queryData(4)">今年</el-button>
            <el-date-picker style="margin-left: 20px;"
                            v-model="selectDate"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions1"
                            @change="dateChange()">
            </el-date-picker>
          </div>
          <div style="width: 100%; height: 450px; margin-left: -10px">
            <v-chart ref="chartRef" :options="lineOptions" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="收入记录" name="second">
          <el-form ref="queryForm" :model="queryParams" size="small" :inline="true">
            <el-form-item label="充值内容" prop="name">
              <el-input
                v-model="queryParams.name"
                placeholder="充值内容"
                clearable
                style="width: 240px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="充值路径" prop="url">
              <el-input
                v-model="queryParams.url"
                placeholder="充值路径"
                clearable
                style="width: 240px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
              <el-button icon="el-icon-refresh" @click="handleResetQuery">重置</el-button>
            </el-form-item>
          </el-form>

          <el-table v-loading="loading" :data="pageList" border>
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="序号" type="index" width="100" />
            <el-table-column label="用户昵称" prop="userId" :show-overflow-tooltip="true" width="100" />
            <el-table-column label="类型" prop="type" :formatter="typeFormat" :show-overflow-tooltip="true" width="250" />
            <el-table-column label="支付价格" prop="payNum" :show-overflow-tooltip="true" width="100"/>
            <el-table-column label="支付渠道" prop="payType" :formatter="payTypeFormat" :show-overflow-tooltip="true" width="250" />
            <el-table-column label="创建时间" prop="createTime" :show-overflow-tooltip="true" />
          </el-table>

          <pagination
            v-show="pagination.total>0"
            :total="pagination.total"
            :page.sync="pagination.page"
            :limit.sync="pagination.limit"
            @pagination="handleQuery"
          />

          <!-- 添加或修改充值配置对话框 -->
          <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="600px">
            <el-form ref="form" :model="form" label-width="100px">
              <el-form-item label="用户昵称" prop="num">
                <el-input v-model="form.userId" placeholder="请输入用户昵称" />
              </el-form-item>
              <el-form-item label="机票数量" prop="num">
                <el-input v-model="form.num" placeholder="请输入机票数量" />
              </el-form-item>
              <el-form-item label="支付价格" prop="num">
                <el-input v-model="form.payNum" placeholder="请输入支付价格" />
              </el-form-item>
              <el-form-item label="支付渠道" prop="num">
                <el-input v-model="form.payType" placeholder="请输入支付渠道" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialog.visible=false">取 消</el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { pluck, equals } from 'ramda'
import { getPayNumStatistics } from '@/api/dashboard'
import { list, detail, update, add, del } from '@/api/finance/userbuy'
import dayjs from 'dayjs'
import { numColorMap } from './const'
export default {
  name: 'Dashboard',
  components: {},
  data() {
    return {
      activeName: 'first',
      numColorMap,
      selectDate: "",
      lineOptions: {},
      queryParams: {
        name: undefined,
      },
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      pageList: [],
      dialog: {
        title: undefined,
        visible: false
      },

      // 表单参数
      form: {},
      loading: false,
      days: 30,
      currMonth: "",
      pickerOptions1: {
        disabledDate(time) {
          const maxToday = new Date()
          maxToday.setTime(maxToday.getTime() - 24 * 60 * 60 * 1000)
          maxToday.setHours(23, 59, 59, 999)
          return time.getTime() > maxToday.getTime()
        }
      },
    }
  },
  created() {
    this.currMonth = dayjs().format('YYYY-MM-DD')
    this.fetchData()
    this.handleQuery()
  },
  methods: {
    dateChange(){

      console.log(this.selectDate)
      if (this.selectDate){
        var number = dayjs(this.selectDate[1]).diff(this.selectDate[0], 'day');
        this.days = number+1
        this.currMonth = this.selectDate[1]
        this.fetchData()
      }
    },
    handleQuery() {
      this.queryParams.payStatus = 2
      this.queryParams.page = this.pagination.page
      this.queryParams.limit = this.pagination.limit
      list(this.queryParams).then(response => {
        this.pageList = response.data
        this.pagination.total = response.total
        this.loading = false
      })
    },
    handleResetQuery() {
      this.pagination = {
        page: 1,
        limit: 10,
        total: 0
      }
      this.queryParams = {
        name: undefined
      }
      this.handleQuery()
    },
    queryData(type){
      if (type==1){
        this.days = 2
        this.currMonth = dayjs().format('YYYY-MM-DD')
      }else if(type==2){
        this.days = dayjs().day()
        this.currMonth = dayjs().format('YYYY-MM-DD')
      }else if(type==3){
        this.days = dayjs().date()
        this.currMonth = dayjs().format('YYYY-MM-DD')
      }else{
        this.days =365
        this.currMonth = dayjs().format('YYYY-MM-DD')
      }

      this.fetchData()
    },
    /**
     * 请求接口获取数据
     */
    async fetchData() {
      const userData = await getPayNumStatistics({
        days: this.days,
        endDate: this.currMonth
      })
      this.lineOptions = this._genLineOptions(userData.data)
    },
    /**
     * 私有方法，辅助fetchData生成折线图配置
     */
    _genLineOptions(content) {
      return {
        title: {
          text: `流水金额  (${this.currMonth})`,
          left: 'center',
          textStyle: {
            color: 'rgba(16, 16, 16, .7)',
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{b0}<br /> 注册用户数量: {c0} '
          formatter: (params) => {
            let dayStr = params.name || ''
            if (equals(1, dayStr.length)) {
              dayStr = dayStr.padStart(2, '0')
            }
            // return `${
            //   dayjs().format("YYYY-MM") + "-" + dayStr
            // }<br/> 注册用户数量: ${params.value || 0}`;
            return `${dayStr}<br/> 金额: ${params.value || 0}`
          }
        },
        color: '#53B095',
        yAxis: {},
        xAxis: {
          type: 'category',
          data: pluck('date')(content)
        },
        series: [
          {
            type: 'bar',
            smooth: true,
            data: pluck('regNum')(content)
          }
        ]
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    statusFormat(row) {
      return row.status === 1 ? '禁用' : '使用中'
    },
    typeFormat(row){
      if (row.type===1){
        return 'VIP购买'
      }
      if (row.type===2){
        return '机票充值'
      }
    },
    payTypeFormat(row){
      if (row.payType===1){
        return '支付宝'
      }
      if (row.payType===2){
        return '微信'
      }
      if (row.payType===3){
        return '苹果'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.echarts {
  width: 90%;
  height: 90%;
}
.dashboard {
  &-container {
    margin: 10px;
    margin-top: 35px;
    &-text-descriptions {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-left: 63px;
      margin-top: -10px;
      .description-row {
        display: flex;
        width: 100px;
        flex-direction: column;
        margin-right: 15%;
        margin-top: 20px;
        &-column {
          .title {
            font-size: 15px;
            margin-top: 9px;
          }
          .total-num {
            margin-top: 9px;
          }
          .yesterday-row {
            font-size: 12px;
            margin-top: 9px;
            color: rgba(16, 16, 16, 0.52);
            display: flex;
            .yesterday-title {
              min-width: 30px;
            }
            .yesterday-count {
              margin-left: 5px;
            }
          }
        }
      }
    }
    .user-reg-statistics {
      width: 100%;
      height: 500px;
      margin-top: 20px;
    }
  }
  &-title {
    font-size: 20px;
    margin-left: 63px;
    margin-top: 10px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
